import React, { ButtonHTMLAttributes } from 'react';
import { Link } from 'gatsby';
import Spinner from '../Spinner';
import { ButtonTypes } from './button-types';
import './button.css';

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  readonly children: React.ReactNode;
  readonly href?: string;
  readonly target?: string;
  readonly width?: string;
  readonly buttonType?: ButtonTypes;
  readonly elementRef?: React.MutableRefObject<null>;
  readonly isLoading?: boolean;
  readonly insideIcon?: React.ReactNode;
};

const getClassByType = (buttonType?: ButtonTypes): string => {
  switch (buttonType) {
    case ButtonTypes.CTA:
      return 'cta-button-container';
    case ButtonTypes.Outline:
      return 'outline-button-container';
    case ButtonTypes.Danger:
      return 'danger-button-container';
    case ButtonTypes.Light:
      return 'light-button-container';
    case ButtonTypes.Primary:
      return 'primary-button-container';
    case ButtonTypes.Secondary:
      return 'secundary-button-container';
    case ButtonTypes.Tertiary:
      return 'tertiary-button-container';
    case ButtonTypes.Quaternary:
      return 'quaternary-button-container';
    case ButtonTypes.Quinary:
      return 'quinary-button-container';
    case ButtonTypes.Senary:
      return 'senary-button-container';
    case ButtonTypes.Septenary:
      return 'septenary-button-container';
    case ButtonTypes.SctecPrimary:
      return 'sctec-primary-button-container';
    case ButtonTypes.SctecOutline:
      return 'sctec-outline-button-container';
    default:
      return 'cta-button-container';
  }
};

function Button({
  children,
  buttonType,
  elementRef,
  width,
  href,
  target,
  isLoading,
  insideIcon,
  ...rest
}: ButtonProps): JSX.Element {
  const className = `standard-button-style ${getClassByType(buttonType)}`;

  if (href) {
    return (
      <Link
        to={href}
        target={target ?? '_blank'}
        className={className}
        ref={elementRef}
        style={{ width, ...rest.style }}
      >
        {isLoading ? (
          <Spinner />
        ) : (
          <>
            {children}
            {insideIcon}
          </>
        )}
      </Link>
    );
  }

  return (
    <button
      ref={elementRef}
      className={className}
      style={{ width, ...rest.style }}
      disabled={isLoading}
      {...rest}
    >
      {isLoading ? (
        <Spinner />
      ) : (
        <>
          {children}
          {insideIcon}
        </>
      )}
    </button>
  );
}

Button.displayName = 'Button';

export default Button;
